module.exports = __webpack_public_path__ + "static/media/sd-card.ea64ec90.svg";